import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * A Hide and Seek Teams team's name, with its creature thumbnail, drawn as the
 * game draws team text (@swtorbit/ui's .hnst-team-name). The admin site and
 * the player client both use it.
 */
import { HNST_TEAMS } from '@swtorbit/shared-socket-events';
import { artUrl } from '@swtorbit/shared-assets';
/** The URL of a team's square creature thumbnail. */
export const hnstTeamIconUrl = (team) => artUrl(`hnst/${team}_creature-square.webp`);
/** A team's creature thumbnail, sized to the text around it (@swtorbit/ui's .hnst-team-icon). */
export function HnstTeamIcon({ team, className = 'hnst-team-icon' }) {
    return _jsx("img", { className: className, src: hnstTeamIconUrl(team), alt: "", "aria-hidden": "true" });
}
export function HnstTeamName({ team }) {
    return (_jsxs("span", { className: `hnst-team-name hnst-team-name--${team}`, children: [_jsx(HnstTeamIcon, { team: team }), " ", HNST_TEAMS[team].name] }));
}
